module.exports = __webpack_public_path__ + "static/media/comment.1ec764b2.png";